import request from "@/utils/request";
import Cookies from "js-cookie";

// 新增或修改应用管理表
export function saveOrUpdate(data) {
  return request({
    url: "/base/application/v1/saveOrUpdate",
    method: "post",
    data: data,
  });
}
// 查询应用管理表
export function applicationList(data) {
  return request({
    url: "/base/application/v1/list",
    method: "post",
    data: data,
  });
}

// 查询部署应用列表
export function getApplictations(data) {
  return request({
    url: "/base/application/v1/getApplictations",
    method: "post",
    data: data,
  });
}
// 删除应用管理表
export function deleteById(data) {
  return request({
    url: `/base/application/v1/deleteById?id=${data.id}`,
    method: "get",
  });
}

// 查询应用管理表
export function getInfoById(data) {
  return request({
    url: `/base/application/v1/getInfoById?id=${data.id}`,
    method: "get",
  });
}

// 获取用户授权的app
export function getUserAppInfo(userId) {
  return request({
    headers: {
        Authorization: Cookies.get("tokenValue"),
        "tenant-id": Cookies.get("schoolId"),
      },
    url: `/base/user/v1/getUserAppInfo?userId=${userId}`,
    method: "get",
  });
}
